var _templateObject;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

import * as React from 'react';
import styled from 'styled-components';
import { prop, ifProp } from 'styled-tools';
import { jsx as _jsx } from "react/jsx-runtime";
var COLUMN_SIZES = ['xs', 'sm', 'md', 'lg', 'xl', 'tp', 'tl', 'sd', 'sw'];
export var getClassName = function getClassName(columns, className) {
  var customClassname = className || '';
  var customColumns = [''];

  if (columns) {
    customColumns = _typeof(columns) === 'object' ? Object.keys(columns).map(function (size) {
      return "col-".concat(size, "-").concat(columns[size]);
    }) : COLUMN_SIZES.map(function (size) {
      return "col-".concat(size, "-").concat(String(columns));
    });
  }

  return [].concat(_toConsumableArray(customColumns), [customClassname]).join(' ').trim();
};
var StyledContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", ";\n  height: ", ";\n  padding: ", ";\n  margin: ", ";\n  margin-left: ", ";\n  margin-right: ", ";\n  max-width: 1280px;\n"])), function (_ref) {
  var columns = _ref.columns,
      width = _ref.width;
  return !columns && "width: ".concat(width);
}, prop('height'), prop('padding'), prop('margin'), ifProp({
  center: true
}, 'auto !important'), ifProp({
  center: true
}, 'auto !important'));

/**
 * Flare's basic container
 * @param props
 * @param {React.ReactNode} children The children of the component.
 * @param {string} width Specifies the width of the container.
 * @param {ColumnsType} columns Specifies the columns.
 * @param {string} height Specifies the height of the container.
 * @param {string} padding Specifies the padding of the container.
 * @param {string} margin Specifies the margin of the container
 * @param {boolean} center Specifies if the content within the container is centered.
 * @param {string} className Adds a className to the component.
 * @param {React.MouseEventHandler<HTMLDivElement>}  onClick Adds an event when clicked.
 */
var Container = function Container(props) {
  var columns = props.columns,
      className = props.className,
      children = props.children;
  return /*#__PURE__*/_jsx(StyledContainer, _objectSpread(_objectSpread({}, props), {}, {
    className: getClassName(columns, className),
    children: children
  }));
};

Container.defaultProps = {
  width: undefined,
  columns: undefined,
  height: 'auto',
  padding: '0',
  className: '',
  margin: 'inherit',
  children: undefined,
  center: false
};
export default Container;